import * as React from "react";

import styles from "./ColumnFilterWrapper.module.css";

export interface ColumnFilterWrapperProps {
  children: React.ReactNode;
  showClear: boolean;
  onClear: () => void;
  hasTrailingIcon?: boolean;
}

export const ColumnFilterWrapper: React.FC<ColumnFilterWrapperProps> = ({
  children,
  showClear,
  onClear,
  hasTrailingIcon,
}) => (
  <span className={[styles[`p-column-filter-wrapper`], showClear ? styles[`has-clear`] : ``].filter(Boolean).join(` `)}>
    {children}
    {showClear && (
      <button
        type="button"
        className={`${styles[`filter-clear-btn`]} ${hasTrailingIcon ? styles[`filter-clear-btn-dropdown`] : ``}`}
        onClick={onClear}
        aria-label="Очистить фильтр">
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </button>
    )}
  </span>
);
